module.exports = __webpack_public_path__ + "static/img/php-41020.8d2efb6e.png";